import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import { mainurl } from '../../Mainurl';
import axios from 'axios';
import { notification } from '../../component/hocs/notification';
import * as XLSX from 'xlsx/xlsx.mjs';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Input,
    InputGroup,
    InputGroupText,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';

import {
    FaEye,
    FaEdit,
    FaPlusCircle,
    FaClipboardList,
    FaSearch,
    FaDownload,
    FaUsers,
    FaMapMarkerAlt,
    FaPhone,
    FaUserTie
} from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';

import ViewFarmer from '../../component/utility/master/ViewFarmer';
import AddFarmer from '../../component/utility/master/AddFarmer';
import EditFarmer from '../../component/utility/master/EditFarmer';
import DeleteFarmer from '../../component/utility/master/DeleteFarmer';

const Farmer = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [f_data, setF_Data] = useState('');
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState(null);

    function toggle() {
        setDisplayConfirmationModal(!displayConfirmationModal);
    }

    const farmer_list = async () => {
        setLoading(true);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "dist_id": 0,
                "block_id": 0,
                "vill_id": 0
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Farmer/box_farmer_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    ids: index + 1,
                    name: row.f_name + " (" + row.f_reg_no + ")",
                    mobile: row.mobile_no,
                    spouse_name: row.f_spouse_name,
                    location: row.state_name + "/" + row.district_name + "/" + row.block_name + "/" + row.village_name,
                    action: (
                        <div className="d-flex gap-2">
                            <Button
                                color="info"
                                size="sm"
                                outline
                                className="d-flex align-items-center"
                                onClick={() => view_handler(row)}
                                title="View Details"
                            >
                                <FaEye size={12} />
                            </Button>
                            <Button
                                color="success"
                                size="sm"
                                outline
                                className="d-flex align-items-center"
                                onClick={() => edit_handler(row)}
                                title="Edit Farmer"
                            >
                                <FaEdit size={12} />
                            </Button>
                            <Button
                                color="danger"
                                size="sm"
                                outline
                                className="d-flex align-items-center"
                                onClick={() => delete_handler(row.f_name, row.farmer_code)}
                                title="Delete Farmer"
                            >
                                <MdDeleteForever size={12} />
                            </Button>
                        </div>
                    ),
                    rawData: row
                };
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} farmers loaded successfully`,
                type: 'success'
            });
            notify();

        } catch (error) {
            let notify = notification({
                message: "Farmer list not found! Try Again",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    }

    const view_handler = (data) => {
        setF_Data(data);
        setMode(3);
    }

    const edit_handler = (data) => {
        setF_Data(data);
        setMode(4);
    }

    function delete_handler(farmerName, farmerCode) {
        setDeleteMsg(`Confirm Delete ${farmerName} [code:${farmerCode}] ?`);
        toggle();
    }

    const back_handler = () => {
        setMode(1);
        // Refresh the list when coming back
        if (tableData.length > 0) {
            farmer_list();
        }
    }

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.name.toLowerCase().includes(value.toLowerCase()) ||
                item.mobile.includes(value) ||
                item.spouse_name.toLowerCase().includes(value.toLowerCase()) ||
                item.location.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredData(filtered);
        }
    };

    // Download Excel functionality
    const download_excel_handler = async () => {
        setDownloadLoading(true);
        
        try {
            let list = tableData.map((row, index) => {
                return {
                    sl_no: index + 1,
                    farmer_name: row.name,
                    mobile_number: row.mobile,
                    spouse_name: row.spouse_name,
                    location: row.location
                };
            });

            if (list.length > 0) {
                let wb = XLSX.utils.book_new(),
                    ws = XLSX.utils.json_to_sheet(list);
                XLSX.utils.book_append_sheet(wb, ws, "Farmer_Report");
                XLSX.writeFile(wb, `farmer_report_${new Date().toISOString().split('T')[0]}.xlsx`);

                let notify = notification({
                    message: "Excel report downloaded successfully!",
                    type: 'success'
                });
                notify();
            } else {
                let notify = notification({
                    message: "No data available for download",
                    type: 'warning'
                });
                notify();
            }
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.ids,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUsers size={12} />
                    Farmer Name
                </div>
            ),
            selector: row => row.name,
            sortable: true,
            width: "25%",
            wrap: true,
            cell: row => (
                <div className="fw-medium text-primary" title={row.name}>
                    {row.name}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaPhone size={12} />
                    Mobile Number
                </div>
            ),
            selector: row => row.mobile,
            sortable: true,
            cell: row => (
                <Badge color="light" className="text-dark" pill>
                    {row.mobile || 'N/A'}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaUserTie size={12} />
                    Spouse Name
                </div>
            ),
            selector: row => row.spouse_name,
            sortable: true,
            wrap: true,
            cell: row => (
                <span title={row.spouse_name}>
                    {row.spouse_name || 'N/A'}
                </span>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaMapMarkerAlt size={12} />
                    Location
                </div>
            ),
            selector: row => row.location,
            sortable: true,
            width: "25%",
            wrap: true,
            cell: row => (
                <small className="text-muted" title={row.location}>
                    {row.location}
                </small>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '150px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Farmer Management' breadcrumbs='Home / Farmer'>
                <Row className='p-3'>
                    {mode === 1 && (
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={farmer_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaClipboardList size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Farmers'}
                                                </Button>
                                                <Button
                                                    color='success'
                                                    size="sm"
                                                    onClick={() => setMode(2)}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    Add New Farmer
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    onClick={download_excel_handler}
                                                    disabled={downloadLoading || tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    {downloadLoading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaDownload size={14} />
                                                    )}
                                                    {downloadLoading ? 'Downloading...' : 'Download Excel'}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search farmers, mobile, location...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUsers size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total Farmers</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaPhone size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {tableData.filter(item => item.mobile && item.mobile !== 'N/A').length}
                                                </h5>
                                                <small>With Mobile Numbers</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaUserTie size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {tableData.filter(item => item.spouse_name && item.spouse_name !== 'N/A').length}
                                                </h5>
                                                <small>With Spouse Info</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaMapMarkerAlt size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(tableData.map(item => item.location.split('/')[1])).size}
                                                </h5>
                                                <small>Districts</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Farmer Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} farmers` :
                                                    'No farmers found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaUsers size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No farmers loaded yet</p>
                                            <small>Click "Load Farmers" to fetch the latest farmer data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading farmers...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No farmers match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {mode === 2 && (
                        <Col xs={12}>
                            <AddFarmer back={() => back_handler()} />
                        </Col>
                    )}

                    {mode === 3 && (
                        <Col xs={12}>
                            <ViewFarmer data={f_data} back={() => back_handler()} />
                        </Col>
                    )}

                    {mode === 4 && (
                        <Col xs={12}>
                            <EditFarmer data={f_data} back={() => back_handler()} />
                        </Col>
                    )}
                </Row>
            </Page>
            <Footer />
            <DeleteFarmer 
                showConfirmationModal={displayConfirmationModal} 
                toggle={toggle} 
                message={deleteMsg}
            />
        </>
    )
}

export default Farmer;